import { useNavigate, Link as RouterLink, Link, useLocation } from 'react-router-dom';
import React ,{ useEffect, useState } from 'react';
import { Box, Typography, Container, FormControlLabel, Radio, RadioGroup, Button, Modal, Checkbox, CircularProgress } from '@mui/material';
import "./App.css"; // CSSファイルをインポート
import api from './api';
import FormRequire from './FormRequire';
import Comp3Sub from './Comp3Sub';
import Comp4Sub from './Comp4Sub';
import FormElectricity from './FormElectricity';
import Comp7Sub from './Comp7Sub';
import Comp8Sub from './Comp8Sub';
import Comp9Sub from './Comp9Sub';
import Comp10Sub from './Comp10Sub';
import Comp11Sub from './Comp11Sub';
import Comp12Sub from './Comp12Sub';
import Comp13Sub from './Comp13Sub';
import Header from './components/Header';
import SubmissionDeadlineNotice from './components/SubmissionDeadlineNotice';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { createRoot } from "react-dom/client";
import Comp3PDF from "./Comp3PDF.js";
import Comp4PDF from "./Comp4PDF.js";
import Comp7PDF from "./Comp7PDF.js";
import Comp8PDF from "./Comp8PDF.js";
import Comp9PDF from "./Comp9PDF.js";
import Comp10PDF from "./Comp10PDF.js";
import Comp10_1PDF from "./Comp10_1PDF.js";
import Comp10_2PDF from './Comp10_2PDF.js';
import Comp11_2PDF from './Comp11_2PDF.js';
import Comp11PDF from "./Comp11PDF.js";
import Comp12PDF from "./Comp12PDF.js";
import Comp13PDF from "./Comp13PDF.js";
import FormRequirePDF from "./FormRequirePDF";
import FormElectricityPDF from "./FormElectricityPDF.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Comp6Sub from './Comp6Sub.js';
import Comp5Sub from './Comp5Sub.js';
import Comp11_2Sub from './Comp11_2Sub.js';
import Comp10_2Sub from './Comp10_2Sub.js';

const CoExhibitMypage = () => {
  const FIELD_CONFIGS = [
    {
      key: 'r1',
      label: '必須書類',
      category: 1,
    },
    {
      key: 'o3',
      label: '運送・会場内荷役',
      category: 3,
    },
    {
      key: 'o4',
      label: '床面工事',
      category: 4,
    },
    {
      key: 'o5',
      label: '電気使用',
      category: 5,
    },
    {
      key: 'o6',
      label: '電気備品',
      category: 6,
    },
    {
      key: 'o7',
      label: '給排水・エア・ガス',
      category: 7,
    },
    {
      key: 'o8',
      label: 'パッケージ装飾等',
      category: 8,
    },
    {
      key: 'o9',
      label: '装飾備品レンタル',
      category: 9,
    },
    {
      key: 'o10',
      label: 'PC・ソフトレンタル',
      category: 10,
    },
    {
      key: 'o10_2',
      label: 'インターネット接続',
      category: 14,
    },
    {
      key: 'o11',
      label: '危険物品',
      category: 11,
    },
    {
      key: 'o11_2',
      label: '防炎対象物',
      category: 15,
    },
    {
      key: 'o12',
      label: 'ゴミ・廃材・廃油処理',
      category: 12,
    },
    {
      key: 'o13',
      label: 'ブース平面図',
      category: 13,
    },
  ];
  const user = JSON.parse(localStorage.getItem("user"));
  const [parentExhibit, setParentExhibit] = useState(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.parent_exhibit;
  });
  const [ownExhibit, setOwnExhibit] = useState(''); // 自社出展する・しないの状態
  const [mypageData, setMypageData] = useState(null);
  const [coMypageData, setCoMypageData] = useState(null);
  const [coMypageLoading, setCoMypageLoading] = useState(false);
  const [coMypageError, setCoMypageError] = useState("");
  const [statusData, setStatusData] = useState(null);
  const [canDownload, setCanDownload] = useState(false);
  const [mypageModalOpen, setMypageModalOpen] = useState(false);
  const [mypageExhibitorId, setMypageExhibitorId] = useState(null);
  const [exhibitors, setExhibitors] = useState([]);
  const [filteredExhibitors, setFilteredExhibitors] = useState([]);
  const itemsPerPage = 150;
  const [exhibitorPage, setExhibitorPage] = useState(1);
  const paginatedExhibitors = filteredExhibitors.slice(
    (exhibitorPage - 1) * itemsPerPage,
    exhibitorPage * itemsPerPage
  );
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [notices, setNotices] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const noticesPerPage = 5;

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const res = await api.get(`/api/notices?skip=${(page - 1) * noticesPerPage}&limit=${noticesPerPage}`);
        setNotices(res.data.items);
        setTotal(res.data.total);
      } catch (err) {
        console.error('お知らせ一覧の取得に失敗:', err);
      }
    };
    fetchNotices();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const scrollToId = localStorage.getItem('scrollToId');
    if (scrollToId) {
      // requestAnimationFrame で描画完了後にスクロール
      requestAnimationFrame(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        localStorage.removeItem('scrollToId');
      });
    }
  }, []);

  const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res1 = await api.get(`/api/mypage/${user.exhibitor_id}`);
        setMypageData(res1.data);
        setCanDownload(res1.data.can_download || false);
      } catch (err) {
        console.error("mypageデータ取得エラー:", err);
        setMypageData(null); // or 空オブジェクトにするか検討
        setCanDownload(false);
      }

      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res2 = await api.get(`/api/submission-status/${user.mypage_id}`);
        setStatusData(res2.data);
      } catch (err) {
        console.error("submission-status取得エラー:", err);
        setStatusData(null);
      }
    };
    fetchData();
  }, []);

  const [selectedFormKey, setSelectedFormKey] = useState(null);
  const [selectedExhibitorId, setSelectedExhibitorId] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);

  const handleFormModalOpenChange = (isOpen) => {
    setFormModalOpen(isOpen);
    if (!isOpen) {
      window.location.reload();
    }
  };
  const [searchStatus, setSearchStatus] = useState('');
  const [filterRequired, setFilterRequired] = useState(true);
  const [filterOptional, setFilterOptional] = useState(true);
  const [filterContractor, setFilterContractor] = useState(true);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);

    api
      .get("/api/co-dashboard", {
        params: {
          status: searchStatus,
          representative_id: user?.representative_id,
        },
      })
      .then(async (res) => {
        setExhibitors(res.data);
        setFilteredExhibitors(res.data);
      })
      .catch((err) => console.error("co-dashboard取得失敗:", err))
      .finally(() => setLoading(false));
  }, [searchStatus, user?.representative_id]);
  const now = new Date(); // 現在の日時

  const getVisibleFields = () => {
    const isAnyFilterChecked = filterRequired || filterOptional || filterContractor;
    if (!isAnyFilterChecked) return FIELD_CONFIGS;

    return FIELD_CONFIGS.filter((field) => {
      const isContractor = field.contractor === true;

      const isRequiredMatch = filterRequired && field.required && !isContractor;
      const isOptionalMatch = filterOptional && !field.required && !isContractor;
      const isContractorMatch = filterContractor && isContractor;

      return isRequiredMatch || isOptionalMatch || isContractorMatch;
    });
  };
  const CO_STATUS_GROUPS = {
    r1: ['r1'],
    o3: ['o3'],
    o4: ['o4'],
    o5: ['o5'],
    o6: ['o6'],
    o7: ['o7'],
    o8: ['o8'],
    o9: ['o9'],
    o10: ['o10'],
    o10_2: ['o10_2'],
    o11: ['o11'],
    o11_2: ['o11_2'],
    o12: ['o12'],
    o13: ['o13'],
  };

  const getCoExhibitOverallStatus = (groupKey) => {
    const targetKeys = CO_STATUS_GROUPS[groupKey] ?? [groupKey];

    if (!Array.isArray(exhibitors) || exhibitors.length === 0) {
      return '未提出';
    }

    const targetStatuses = exhibitors.flatMap((exhibitor) =>
      targetKeys.map((key) => ({
        exhibitorStatus: exhibitor[`${key}_exhibitor_status`] ?? null,
        hostStatus: exhibitor[`${key}_host_status`] ?? null,
      }))
    );

    if (targetStatuses.length === 0) {
      return '未提出';
    }

    const isAllHostConfirmed = targetStatuses.every(
      ({ hostStatus }) => hostStatus === '確認済'
    );
    if (isAllHostConfirmed) {
      return '完了';
    }

    const isAllExhibitorSubmittedOrSkipped = targetStatuses.every(
      ({ exhibitorStatus }) =>
        exhibitorStatus === '提出済み' || exhibitorStatus === '申請しない'
    );
    if (isAllExhibitorSubmittedOrSkipped) {
      return '確認中';
    }

    return '未提出';
  };

  const renderCoStatusIcon = (groupKey, alt) => {
    if (loading) {
      return <CircularProgress size={32} />;
    }

    return (
      <img
        src={getImageByStatusCo(getCoExhibitOverallStatus(groupKey))}
        alt={alt}
        style={{ width: '60px' }}
      />
    );
  };
  const renderForm = (formKey, exhibitorId) => {
    const key = `${formKey}-${exhibitorId}`;
    switch (formKey) {
      case 'r1':
        return (
          <FormRequire
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o3':
        return (
          <Comp3Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o4':
        return (
          <Comp4Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o5':
        return (
          <Comp5Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o6':
        return (
          <Comp6Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o7':
        return (
          <Comp7Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o8':
        return (
          <Comp8Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o9':
        return (
          <Comp9Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10':
        return (
          <Comp10Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10_2':
        return (
          <Comp10_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11':
        return (
          <Comp11Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11_2':
        return (
          <Comp11_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o12':
        return (
          <Comp12Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o13':
        return (
          <Comp13Sub
            key={key}
            exhibitorId={exhibitorId}
            isModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={handleFormModalOpenChange}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      default:
        return <p>フォームが見つかりませんでした</p>;
    }
  };

  const handleStatusClick = async (formKey, exhibitorId) => {

    setSelectedFormKey(formKey);
    setSelectedExhibitorId(exhibitorId);

    try {
      setFormModalOpen(true)
    } catch (error) {
      console.error(error);
      alert('エラー');
    }
  };

  const handleMypageOpen = (exhibitorId) => {
    setCoMypageData(null);
    setCoMypageError("");
    setMypageExhibitorId(exhibitorId);
    setMypageModalOpen(true);
  };

  useEffect(() => {
    if (!mypageModalOpen || mypageExhibitorId == null) return;

    let isActive = true;
    const fetchCoMypage = async () => {
      setCoMypageLoading(true);
      setCoMypageError("");
      try {
        const response = await api.get(`/api/mypage/${mypageExhibitorId}`);
        if (isActive) setCoMypageData(response.data);
      } catch (error) {
        console.error("co-exhibit mypage fetch failed:", error);
        if (isActive) {
          const status = error.response?.status;
          setCoMypageError(status === 403
            ? "この共同子の会社情報を閲覧する権限がありません。"
            : "会社情報の取得に失敗しました。時間をおいて再度お試しください。");
        }
      } finally {
        if (isActive) setCoMypageLoading(false);
      }
    };

    fetchCoMypage();
    return () => { isActive = false; };
  }, [mypageModalOpen, mypageExhibitorId]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  const getImageByStatus = (status) => {
    switch (status) {
      case '再提出':
        return "/status_再提出.png";
      case '確認済':
        return "/status_確認済み.png"; 
      case '提出済み':
        return "/status_確認中.png";
      case '未提出':
        return "/status_未提出.png";
      case '申請しない':
        return "/status_申請しない.png"; 
      default:
        return "/status_未提出.png";
    }
  };

  const getImageByStatusCo = (status) => {
    switch (status) {
      case '完了':
      case '確認済':
        return "/status_確認済み.png";
      case '確認中':
        return "/status_確認中.png";
      case '未提出':
        return "/status_未提出.png";
      case '再提出':
        return "/status_再提出.png";
      default:
        return "/status_未提出.png";
    }
  };
  const getStatusImage = (status) => {
      switch (status) {
        case '確認済':
            return '/status_確認済み.png';
        case '確認中':
            return '/status_確認中.png';
        case '未確認':
            return '/status_未確認.png';
        case '1のみ確認済':
            return '/status_1のみ確認済.png';
        case '2のみ確認済':
            return '/status_2のみ確認済.png';
        
        // 👇 提出ステータス追加（例）
        case '提出済み':
            return '/status_確認中.png';
        case '未提出':
            return '/status_未提出.png';
        case '再提出':
            return '/status_再提出.png';
        case '申請しない':
            return '/status_申請しない.png';


        default:
            return '/status_未提出.png';
      }
  };

  const getPreferredStatus = (status, hostStatus) => {
    if (status === "再提出") {
      return "再提出";
    }

    return hostStatus === "確認済" ? "確認済" : (status || "未提出");
  };

  const getPreferredStatusForElec = (o5Status, o6Status, o5HostStatus, o6HostStatus) => {
      // 最優先：両方確認済
      if (o5HostStatus === "確認済" && o6HostStatus === "確認済") {
          return "確認済";
      }

      // 両方申請しない
      if (o5Status === "申請しない" && o6Status === "申請しない") {
          return "申請しない";
      }

      // どちらかが提出済みで、もう一方が申請しない
      if (
          (o5Status === "提出済み" && o6Status === "申請しない") ||
          (o5Status === "申請しない" && o6Status === "提出済み") ||
          (o5Status === "提出済み" && o6Status === "提出済み")
      ) {
          return "提出済み";
      }

      // 両方未提出
      if (o5Status === "未提出" && o6Status === "未提出") {
          return "未提出";
      }

      // 上記のいずれでもない場合は "未提出" 扱い（または要相談）
      return "未提出";
  };

  const [isHovered, setIsHovered] = useState(false);

   const pdfItems = [
      { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展の手引き', path: '/出展の手引き.pdf' },
      { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      { label: '出展者証について', path: '/出展者証について.pdf' },
      { label: '出展者駐車許可証(見本)', path: '/出展者専用駐車許可証兼搬出車両証見本.pdf' },
      { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      { label: '広報宣伝計画', path: '/広報宣伝計画.pdf' },
      { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      { label: '出展者一覧', path: '/出展者一覧.pdf' },
      { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      { label: '各運送サービスのご案内', path: '/各運送サービスのご案内.zip' },
      { label: '会場内飲食のご案内', path: '/会場内飲食のご案内.pdf' },
      { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

   const renderMenuItems = () => (
        <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
            <div className="submenu">
              {pdfItems.map((item, index) => (
                <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
                </a>
              ))}
            </div>
          )}
        </div>
    );

    const [saving, setSaving] = useState(false);

    const deadline = new Date("2026-09-30T23:59:59");
    const today = new Date();

    // 残り日数計算
    const remainingDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

    const handleSave = async () => {
      if (!ownExhibit) return;

      const user = JSON.parse(localStorage.getItem("user"));
      const exhibitorId = user.exhibitor_id;

      try {
        setSaving(true);

        await api.post("/api/save-own-exhibit", {
          exhibitor_id: exhibitorId,
          parent_exhibit: ownExhibit === "yes", // ← boolで渡す
        });

        // localStorage更新
        const newUser = {
          ...user,
          parent_exhibit: ownExhibit === "yes",
        };
        localStorage.setItem("user", JSON.stringify(newUser));
        setParentExhibit(newUser.parent_exhibit); // ← state更新

        alert("保存しました！");
      } catch (error) {
        console.error(error);
        alert("保存に失敗しました");
      } finally {
        setSaving(false);
      }
    };

    useEffect(() => {
      if (parentExhibit === true) {
        setOwnExhibit("yes");
      } else if (parentExhibit === false) {
        setOwnExhibit("no");
      } else {
        setOwnExhibit(""); // null の場合は選択なし
      }
    }, [parentExhibit]);

  const handlePdfDownload = async (exhibitorId, companyName) => {

    try {
      const response = await api.get(
        `/api/pdf-download/${exhibitorId}`,
        {
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            companyName,
            t: new Date().getTime()
          }
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const safeFileName = companyName.replace(/[\\/:*?"<>|]/g, '_') + '.pdf';

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', safeFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      alert("PDFのダウンロードが完了しました。");
    } catch (error) {
      console.error("PDFダウンロードに失敗:", error);
      alert("PDFのダウンロードに失敗しました。");
    }
  };

  const [checkedPdfIds, setCheckedPdfIds] = useState([]);
  const [checkedChildPdfIds, setCheckedChildPdfIds] = useState([]);
  const isCheckable = (key) => {
    const status = statusData?.[`${key}_status`];

    return ![
      "",
      undefined,
      null,
      "未提出",
      "申請しない",
    ].includes(status);
  };
  const togglePdfCheck = (key) => {
    if (!isCheckable(key)) return;

    setCheckedPdfIds((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };
  const handleColumnSelect = () => {
    const keys = FIELD_CONFIGS
      .map((field) => field.key)
      .filter((key) => isCheckable(key));

    const allChecked = keys.every((key) =>
      checkedPdfIds.includes(key)
    );

    setCheckedPdfIds((prev) => {
      if (allChecked) {
        return prev.filter((id) => !keys.includes(id));
      }

      return [...new Set([...prev, ...keys])];
    });
  };

  const getCoExhibitCurrentStatus = (exhibitor, field) => {
    const { key } = field;
    const exhibitorKey = `${key}_exhibitor_status`;
    const hostKey = `${key}_host_status`;
    const corporateKey = `${key}_corporate_status`;

    let exhibitorStatus = exhibitor[exhibitorKey] ?? '未提出';

    if (key === 'o5') {
      const o5 = exhibitor.o5_exhibitor_status;
      const o6 = exhibitor.o6_exhibitor_status;

      if (o5 === '申請しない' && (o6 === '未提出' || o6 === '提出済み')) {
        exhibitorStatus = o6;
      } else if (o5 === '申請しない' && o6 === '申請しない') {
        exhibitorStatus = '申請しない';
      } else {
        exhibitorStatus = o5 ?? '未提出';
      }
    }

    let hostStatus = exhibitor[hostKey];

    if (key === 'o5') {
      const o5 = exhibitor.o5_host_status;
      const o6 = exhibitor.o6_host_status;

      if (o5 === '申請しない' && (o6 === '未確認' || o6 === '確認済')) {
        hostStatus = o6;
      } else if (o5 === '申請しない' && o6 === '申請しない') {
        hostStatus = '申請しない';
      } else {
        hostStatus = o5;
      }
    }

    const candidates = [
      exhibitorStatus,
      hostStatus,
      exhibitor[corporateKey],
    ].filter(Boolean);

    const STATUS_PRIORITY = [
      '再提出',
      '確認済',
      '申請しない',
      '提出済み',
      '確認中',
      '未確認',
      '1のみ確認済',
      '2のみ確認済',
      '未提出',
    ];

    let currentStatus = '未提出';
    for (const status of STATUS_PRIORITY) {
      if (candidates.includes(status)) {
        currentStatus = status;
        break;
      }
    }

    return currentStatus;
  };

  const isChildPdfCheckable = (exhibitor, field) =>
    getCoExhibitCurrentStatus(exhibitor, field) !== '申請しない';

  const toggleChildPdfCheck = (checkboxId) => {
    setCheckedChildPdfIds((prev) =>
      prev.includes(checkboxId)
        ? prev.filter((id) => id !== checkboxId)
        : [...prev, checkboxId]
    );
  };

  const handleChildColumnSelect = (key) => {
    const field = getVisibleFields().find((item) => item.key === key);
    if (!field) return;

    const columnIds = filteredExhibitors
      .filter((exhibitor) => isChildPdfCheckable(exhibitor, field))
      .map((exhibitor) => `${exhibitor.exhibitor_id}_${key}`);

    const allChecked = columnIds.every((id) => checkedChildPdfIds.includes(id));

    setCheckedChildPdfIds((prev) => {
      if (allChecked) {
        return prev.filter((id) => !columnIds.includes(id));
      }

      return [...prev, ...columnIds.filter((id) => !prev.includes(id))];
    });
  };
  const [rentalItems, setRentalItems] = useState([]);

  useEffect(() => {
      const fetchItems = async () => {
          try {
              const res = await api.get("/api/master/items-o9");
              setRentalItems(res.data || []);
          } catch (err) {
              console.error("アイテム取得エラー:", err);
          }
      };
      fetchItems();
  }, []);

  const [pcItems, setPcItems] = useState([]);

  useEffect(() => {
      const fetchItems = async () => {
          try {
              const res = await api.get("/api/master/items-o10");
              setPcItems(res.data || []);
          } catch (err) {
              console.error("アイテム取得エラー:", err);
          }
      };
      fetchItems();
  }, []);

  const [elecItems, setElecItems] = useState([]);
  useEffect(() => {
      const fetchItems = async () => {
          try {
              const res = await api.get("/api/master/items");
              setElecItems(res.data || []);
          } catch (err) {
              console.error("アイテム取得エラー:", err);
          }
      };
      fetchItems();
  }, []);
  const [gasChecked, setGasChecked] = useState({
    water: false,
    air: false,
    gas: false,
  });
  const [checked, setChecked] = useState({
    pack: false,
    storage: false,
    iphone: false,
    add: false,
  });
  const [cleanChecked, setCleanChecked] = useState({
    garbage: false,
    oil: false,
    clean: false,
  });
  const [checkedPC, setCheckedPC] = useState({
    pc: false
  });
  const [selectedPlans, setSelectedPlans] = useState([]);
  const waitForIdleAndStableDOM = (targetElement, timeout = 3000) =>
    new Promise((resolve) => {
      let stableCount = 0;
      let lastHeight = targetElement.offsetHeight;

      const checkStable = () => {
        const nowHeight = targetElement.offsetHeight;
        if (nowHeight === lastHeight) {
          stableCount++;
          if (stableCount >= 3) {
            return resolve();
          }
        } else {
          stableCount = 0;
          lastHeight = nowHeight;
        }
        setTimeout(checkStable, 150);
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          setTimeout(checkStable, 150);
        }, { timeout });
      } else {
        setTimeout(checkStable, 150);
      }
  });
  const fetchUserId = async (exhibitor_id) => {
    try {
      const res = await api.get(`/api/users/${exhibitor_id}`);
      if (res.status === 200) {
        return res.data.user_id;
      }
    } catch (err) {
      console.error("user_id取得失敗:", err);
    }
    return null;
  };

  const downloadPdfTargets = async (targets) => {
    if (!targets.length) {
      alert("出力対象が選択されていません");
      return;
    }

    const targetsWithUser0 = await Promise.all(
      targets.map(async (row) => {
        const user_id = await fetchUserId(row.exhibitor_id);
        return {
          ...row,
          User0: user_id === 0,
        };
      })
    );

    for (const row of targetsWithUser0) {
      for (const fieldKey of row.selectedCategories) {
        const form = row.categories[fieldKey];
        const fieldConfig = FIELD_CONFIGS.find((field) => field.key === fieldKey);

        const reqData = {
          company_name: form.company_name,
          booth_number: form.booth_number,
          department: form.department,
          address: form.address,
          phone_number: form.phone_number,
          email: form.email,
          user_name: form.user_name,
          r1: form.r1?.[0] || {},
          r2: form.r2?.[0] || {},
        };

        if (!fieldConfig) continue;

        const container = document.createElement("div");
        document.body.appendChild(container);
        const root = createRoot(container);

        const renderComponent = (formKey) => {
          switch (formKey) {
            case 'r1': {
              const hasPackage = !!(
                reqData?.r1?.package_company_name ||
                reqData?.r1?.package_company_tel ||
                reqData?.r1?.package_phone_number ||
                reqData?.r1?.package_company_zip ||
                reqData?.r1?.package_company_address ||
                reqData?.r1?.package_company_fax ||
                reqData?.r1?.package_name
              );

              const hasElec = !!(
                reqData?.r1?.elec_company_name ||
                reqData?.r1?.elec_company_tel ||
                reqData?.r1?.elec_phone_number ||
                reqData?.r1?.elec_company_zip ||
                reqData?.r1?.elec_company_address ||
                reqData?.r1?.elec_company_fax ||
                reqData?.r1?.elec_name
              );

              const hasInfla = !!(
                reqData?.r1?.infla_company_name ||
                reqData?.r1?.infla_company_tel ||
                reqData?.r1?.infla_phone_number ||
                reqData?.r1?.infla_company_zip ||
                reqData?.r1?.infla_company_address ||
                reqData?.r1?.infla_company_fax ||
                reqData?.r1?.infla_name
              );

              const hasCargo = !!(
                reqData?.r1?.cargo_company_name ||
                reqData?.r1?.cargo_company_tel ||
                reqData?.r1?.cargo_phone_number ||
                reqData?.r1?.cargo_company_zip ||
                reqData?.r1?.cargo_company_address ||
                reqData?.r1?.cargo_company_fax ||
                reqData?.r1?.cargo_name
              );

              const checkedR1 = {
                has_package_company: hasPackage,
                has_elec_company: hasElec,
                has_infla_company: hasInfla,
                has_cargo_company: hasCargo,
              };

              return <FormRequirePDF reqData={{ ...reqData, r1: { ...reqData.r1, ...checkedR1 } }} User0={row.User0} />;
            }
            case 'o3':
              return <Comp3PDF formData={form} />;
            case 'o4':
              return <Comp4PDF formData={form} />;
            case 'o5': {
              const hasV100 =
                form?.o5?.[0]?.details_100?.some((d) =>
                  d.device_100_name || d.quantity_100 || d.number_100 || d.total_100 || d.ex_100
                ) ||
                (form?.o5?.[0]?.quantity_100v !== null &&
                  form?.o5?.[0]?.quantity_100v !== undefined &&
                  Number(form?.o5?.[0]?.quantity_100v) > 0);

              const hasV200 =
                form?.o5?.[0]?.details_200?.some((d) =>
                  d.device_200_name || d.quantity_200 || d.number_200 || d.total_200 || d.ex_200
                ) ||
                (form?.o5?.[0]?.quantity_200v !== null &&
                  form?.o5?.[0]?.quantity_200v !== undefined &&
                  Number(form?.o5?.[0]?.quantity_200v) > 0);

              const localChecked = {
                v100: !!hasV100,
                v200: !!hasV200,
              };

              return <FormElectricityPDF elecData={form} checked={localChecked} elecItems={elecItems} />;
            }
            case 'o7': {
              const hasWater = form.water;
              const hasAir = form.air;
              const hasGas = form.gas;

              const gasObj = {
                water: !!hasWater,
                air: !!hasAir,
                gas: !!hasGas,
              };

              setGasChecked(gasObj);
              return <Comp7PDF formData={form} checked={gasObj} />;
            }
            case 'o8': {
              let plans = [];
              if (form.plan && Array.isArray(form.plan)) {
                plans = form.plan.map((p) => ({
                  value: p.value,
                  label: p.label,
                  quantity: p.quantity || 1,
                }));
                setSelectedPlans(plans);
              }

              const hasPack =
                plans.length > 0 ||
                form.plate_select ||
                form.plate_info ||
                form.carpet_color ||
                form.outlet ||
                form.add_select ||
                (form.add_detail && form.add_detail !== "A:0,B:0,C:0,D:0");

              const hasStorage =
                (form.normal_box && form.normal_box !== 0) ||
                (form.other_box && form.other_box !== 0);

              const hasIphone = form.smartphone !== null || (form.add_smartphone && form.add_smartphone > 0);
              const hasAdd = form.add_smartphone && form.add_smartphone > 0;

              const checkedObj = {
                pack: !!hasPack,
                storage: !!hasStorage,
                iphone: !!hasIphone,
                add: !!hasAdd,
              };

              setChecked(checkedObj);
              return <Comp8PDF formData={form} checked={checkedObj} selectedPlans={plans} />;
            }
            case 'o9':
              return <Comp9PDF formData={form} rentalItems={rentalItems} />;
            case 'o10': {
              const hasPC =
                !!(form.move_in ||
                form.move_in_detail ||
                form.move_out ||
                form.move_out_detail ||
                (Array.isArray(form.details) && form.details.length > 0));
              const checkedPCObj = {
                pc: !!hasPC,
              };
              setCheckedPC(checkedPCObj);
              return <Comp10_1PDF formData={form} items={pcItems} checked={checkedPCObj} />;
            }
            case 'o10_2':
              return <Comp10_2PDF formData={form} />;
            case 'o11':
              return <Comp11PDF formData={form} />;
            case 'o11_2':
              return <Comp11_2PDF formData={form} />;
            case 'o12': {
              const hasGarbage = form.garbage_plan?.length > 0;
              const hasOil = form.lubricating_oil || form.waste_oil;
              const hasClean = form.cleanup;

              const cleanObj = {
                garbage: !!hasGarbage,
                oil: !!hasOil,
                clean: !!hasClean,
              };

              setCleanChecked(cleanObj);
              return <Comp12PDF formData={form} checked={cleanObj} />;
            }
            case 'o13':
              return <Comp13PDF formData={form} />;
            default:
              return <p>フォームが見つかりませんでした</p>;
          }
        };

        root.render(
          <div
            style={{
              width: "210mm",
              minHeight: "297mm",
              padding: "10mm",
              background: "#fff",
              overflow: "visible",
            }}
          >
            {renderComponent(fieldKey)}
          </div>
        );

        const baseUrl =
          window.location.hostname === 'localhost'
            ? 'http://127.0.0.1:8000'
            : 'https://messenagoya.ex-link.net';

        await waitForIdleAndStableDOM(container);
        container.style.height = `${container.scrollHeight}px`;

        if (fieldKey === 'o13') {
          const res = await fetch(`${baseUrl}/api/o13/download/${row.exhibitor_id}`, { cache: 'no-store' });
          if (!res.ok) throw new Error('zip ダウンロード失敗');
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${row.company_name}_ブース平面図.zip`;
          a.click();
          window.URL.revokeObjectURL(url);

          await waitForIdleAndStableDOM(container);

          const canvas = await html2canvas(container, { scale: 2, useCORS: true, allowTaint: true, backgroundColor: '#fff' });
          const imgData = canvas.toDataURL('image/jpeg', 0.6);
          const pdf = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            compress: true,
          });
          pdf.addImage(imgData, 'JPEG', 0, 0, 210, (canvas.height * 210) / canvas.width);
          pdf.save(`${row.company_name}_o13.pdf`);
        } else {
          const canvas = await html2canvas(container, {
            scale: 1.3,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
          });

          const imgData = canvas.toDataURL('image/jpeg', 0.6);
          const imgWidth = 210;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const pdf = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            compress: true,
          });
          let heightLeft = imgHeight;
          let position = 0;

          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position -= pageHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          const company = row.company_name || 'output';
          const safeCompany = company.replace(/[\\/:*?"<>|]/g, '_');
          const label = fieldConfig.label || fieldKey;

          pdf.save(`${safeCompany}_${label}.pdf`);
        }

        root.unmount();
        document.body.removeChild(container);
        await new Promise((res) => setTimeout(res, 800));
      }
    }
  };

  const handlePDFDownload = async () => {
    const fieldMap = Object.fromEntries(FIELD_CONFIGS.map((f) => [f.key, f]));
    if (!mypageData?.exhibitor_id) return;

    const fetchCorporateInfo = async () => {
      try {
        const res = await api.get(`/api/pdf-mine/${mypageData?.exhibitor_id}`);

        if (res.status !== 200) {
          throw new Error('データ取得に失敗しました');
        }

        return res.data;
      } catch (err) {
        console.error('API呼び出し失敗:', err);
        throw err;
      }
    };

    const corporateInfo = await fetchCorporateInfo();
    const corporateDataMap = corporateInfo.data;

    const targets = checkedPdfIds
      .map((key) => {
        const fieldConfig = fieldMap[key];
        if (!fieldConfig) return null;

        const category = fieldConfig.category;
        const forms = corporateDataMap[category];
        if (!forms) return null;

        const matchedForm = forms.find((f) => f.exhibitor_id === mypageData.exhibitor_id);
        if (!matchedForm) return null;

        return {
          exhibitor_id: mypageData.exhibitor_id,
          company_name: matchedForm.company_name,
          selectedCategories: [key],
          categories: {
            [key]: matchedForm,
          },
        };
      })
      .filter(Boolean);

    await downloadPdfTargets(targets);
  };

  const handleChildPDFDownload = async () => {
    const fieldMap = Object.fromEntries(FIELD_CONFIGS.map((f) => [f.key, f]));
    const selectedPairs = checkedChildPdfIds.map((id) => {
      const [exhibitor_id_raw, ...keyParts] = id.split('_');
      return { exhibitor_id: Number(exhibitor_id_raw), key: keyParts.join('_') };
    });

    const groupedSelections = selectedPairs.reduce((map, { exhibitor_id, key }) => {
      if (!map.has(exhibitor_id)) {
        map.set(exhibitor_id, []);
      }
      map.get(exhibitor_id).push(key);
      return map;
    }, new Map());

    const targets = (
      await Promise.all(
        Array.from(groupedSelections.entries()).map(async ([exhibitor_id, selectedCategories]) => {
          try {
            const res = await api.get(`/api/pdf-mine/${exhibitor_id}`);
            if (res.status !== 200) {
              throw new Error('データ取得に失敗しました');
            }

            const corporateDataMap = res.data.data;
            const categories = {};
            let companyName = exhibitors.find((item) => item.exhibitor_id === exhibitor_id)?.company_name || '';

            for (const key of [...new Set(selectedCategories)]) {
              const fieldConfig = fieldMap[key];
              if (!fieldConfig) continue;

              const forms = corporateDataMap[fieldConfig.category];
              if (!forms) continue;

              const matchedForm = forms.find((form) => form.exhibitor_id === exhibitor_id);
              if (!matchedForm) continue;

              categories[key] = matchedForm;
              if (!companyName) {
                companyName = matchedForm.company_name;
              }
            }

            const availableKeys = Object.keys(categories);
            if (!availableKeys.length) {
              return null;
            }

            return {
              exhibitor_id,
              company_name: companyName || `exhibitor_${exhibitor_id}`,
              selectedCategories: availableKeys,
              categories,
            };
          } catch (err) {
            console.error(`共同出展者PDFデータ取得失敗: ${exhibitor_id}`, err);
            return null;
          }
        })
      )
    ).filter(Boolean);

    await downloadPdfTargets(targets);
  };

  const renderMainContent = () => {
    if (parentExhibit === null) {
      return (
        <Box sx={{ margin: 'auto', mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            {mypageData?.company_name}様<br />
            メッセナゴヤにご出展いただきありがとうございます。<br />
            自社出展はされますか？
          </Typography>
          <RadioGroup
            value={ownExhibit}
            onChange={(e) => setOwnExhibit(e.target.value)}
            row
            aria-label="own-exhibit"
            name="own-exhibit-group"
          >
            <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
            <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
          </RadioGroup>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={handleSave}
            disabled={saving || ownExhibit === ""}
          >
            保存する
          </Button>
        </Box>
      );
    }

    if (parentExhibit === true) {
    return (
      <>
      <Box sx={{ margin: 'auto', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          自社（親出展者）の出展有無を選択してください。
        </Typography>
        <RadioGroup
          value={ownExhibit}
          onChange={(e) => setOwnExhibit(e.target.value)}
          row
          aria-label="own-exhibit"
          name="own-exhibit-group"
        >
          <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
          <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
        </RadioGroup>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleSave}
          disabled={saving || ownExhibit === ""}
        >
          保存する
        </Button>
      </Box>
      <Box sx={{ margin: 'auto', mt: 4 }} className="form-status-box">
        <Box className="sm-column sm-p-b-15" sx={{display:'flex',justifyContent:'space-between',alignItems:'center',borderRadius: '15.68px 15.68px 0 0',backgroundColor:'#7d7d7d'}}>
          <Typography variant="h6" className='form-status-title' gutterBottom>　出展者（親）申請書提出状況</Typography>
          <Box className="flex-wrap">
            <Button variant="contained" color="secondary" onClick={handlePDFDownload} disabled={checkedPdfIds.length === 0} sx={{ px: 2 }}>PDFダウンロード</Button>
            <Button variant="contained" color="primary" onClick={handleColumnSelect} sx={{ px: 2 }}>一括チェック</Button>
          </Box>
        </Box>
        <Container className='sm-pad0' sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          {/* 必須書類のまま */}
          <Box sx={{ textAlign: 'center', borderBottom: '1px solid #ccc', pb: 2 }}>
                <Typography onClick={() => navigate('/form-require')} sx={{cursor:'pointer'}}>必須提出書類<br />出展責任者登録、搬入・搬出計画登録</Typography>
                <Box sx={{display: 'flex',flexDirection: 'column', alignItems: 'center'}}>
                  <img
                  src={getImageByStatus(
                      getPreferredStatus(
                      statusData?.r1_status,
                      statusData?.r1_host_status,
                      )
                  )}
                  alt="必須書類ステータス"
                  style={{ width: '60px' }}
                  onClick={() => navigate('/form-require')}
                  />
                  <Checkbox
                    disabled={!isCheckable("r1")}
                    checked={checkedPdfIds.includes("r1")}
                    onChange={(e) => {
                      e.stopPropagation(); // ← これ超重要（遷移防止）
                      togglePdfCheck("r1");
                    }}
                  />
                </Box>
            </Box>

            <Typography sx={{textAlign: 'center'}}>任意提出書類</Typography>

            <Box sx={{ display: 'flex', justifyContent: 'space-around', pb: 1 }} className="form-grid b-b-ash">
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o3_status,
                        statusData?.o3_host_status,
                    )
                    )}
                    alt="運送・会場内荷役作業申込"
                    onClick={() => navigate('/form-o-3')}
                    style={{ width: '60px' }}
                  />
                  <Checkbox
                    disabled={!isCheckable("o3")}
                    checked={checkedPdfIds.includes("o3")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o3");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-3')}>運送・会場内荷役作業申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection: 'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o4_status,
                        statusData?.o4_host_status,
                    )
                    )}
                    alt="床面工事施工申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-4')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o4")}
                    checked={checkedPdfIds.includes("o4")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o4");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-4')}>床面工事施工申込</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems: 'center'}}>
                    <img
                      src={getImageByStatus(
                        getPreferredStatus(
                          statusData?.o5_status,
                          statusData?.o5_host_status
                        )
                      )}
                      alt="電気使用申込"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-5')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o5")}
                      checked={checkedPdfIds.includes("o5")}
                      onChange={(e) => {
                        e.stopPropagation();
                        togglePdfCheck("o5");
                      }}
                    />
                  </Box>
                  <Typography onClick={() => navigate('/form-o-5')}>電気（電力）使用申込</Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                        getPreferredStatus(
                          statusData?.o6_status,
                          statusData?.o6_host_status
                        )
                      )}
                      alt="電気備品レンタル申込"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-6')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o6")}
                      checked={checkedPdfIds.includes("o6")}
                      onChange={(e) => {
                        e.stopPropagation();
                        togglePdfCheck("o6");
                      }}
                    />
                  </Box>
                  <Typography onClick={() => navigate('/form-o-6')}>電気備品レンタル申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o7_status,
                        statusData?.o7_host_status,
                    )
                    )}
                    alt="給排水・エア・ガス工事申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-7')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o7")}
                    checked={checkedPdfIds.includes("o7")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o7");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-7')}>給排水・エア・ガス工事申込</Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-around' , borderBottom: '1px solid #ccc' , pb: 1 }} className="form-grid">
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o8_status,
                        statusData?.o8_host_status,
                    )
                    )}
                    alt="パッケージ申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-8')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o8")}
                    checked={checkedPdfIds.includes("o8")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o8");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-8')}>パッケージ（装飾・出展者専用倉庫・iPhone）申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o9_status,
                        statusData?.o9_host_status,
                    )
                    )}
                    alt="装飾備品レンタル申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-9')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o9")}
                    checked={checkedPdfIds.includes("o9")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o9");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-9')}>装飾備品レンタル申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',alignItems:'center',flexDirection:'column'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o10_status,
                        statusData?.o10_host_status,
                    )
                    )}
                    alt="PC・ソフトレンタル申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-10')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o10")}
                    checked={checkedPdfIds.includes("o10")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o10");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-10')}>PC・ソフトレンタル申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o10_2_status,
                        statusData?.o10_2_host_status,
                    )
                    )}
                    alt="インターネット接続申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-10_2')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o10_2")}
                    checked={checkedPdfIds.includes("o10_2")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o10_2");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-10_2')}>インターネット接続申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o11_2_status,
                        statusData?.o11_2_host_status,
                    )
                    )}
                    alt="防炎対象物品申請"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-11_2')}
                  />
                  <Checkbox
                  disabled={!isCheckable("o11_2")}
                    checked={checkedPdfIds.includes("o11_2")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o11_2");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-11_2')}>防炎対象物品申請</Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', pb: 2 }} className="form-grid">
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o11_status,
                        statusData?.o11_host_status,
                    )
                    )}
                    alt="危険物品の許可申請"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-11')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o11")}
                    checked={checkedPdfIds.includes("o11")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o11");
                    }}
                  />
                  </Box>
                  <Typography onClick={() => navigate('/form-o-11')}>危険物品の許可申請</Typography>
                </Box>
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24.5%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o12_status,
                        statusData?.o12_host_status,
                    )
                    )}
                    alt="ゴミ・廃材・廃油処理と小間内清掃申込"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-12')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o12")}
                    checked={checkedPdfIds.includes("o12")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o12");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-12')}>ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
                </Box>

                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '24%',
                    borderRight: '1px solid #ccc',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                    gap: 1,
                    cursor: 'pointer',
                    '&:last-child': { borderRight: 'none' },
                }}
                className="form-card"
                >
                <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <img
                    src={getImageByStatus(
                    getPreferredStatus(
                        statusData?.o13_status,
                        statusData?.o13_host_status,
                    )
                    )}
                    alt="ブース平面図"
                    style={{ width: '60px' }}
                    onClick={() => navigate('/form-o-13')}
                  />
                  <Checkbox
                    disabled={!isCheckable("o13")}
                    checked={checkedPdfIds.includes("o13")}
                    onChange={(e) => {
                      e.stopPropagation();
                      togglePdfCheck("o13");
                    }}
                  />
                </Box>
                <Typography onClick={() => navigate('/form-o-13')}>ブース平面図</Typography>
                </Box>
            </Box>
          </Container>
      </Box>
      </>
    );
  }
  if (parentExhibit === false) {
  return (
    <Box sx={{ margin: 'auto', mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        自社出展【しない】と登録されています。
      </Typography>
      <Box sx={{ margin: 'auto', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          自社出展の設定を変更する場合はこちらから変更してください。
        </Typography>
        <RadioGroup
          value={ownExhibit}
          onChange={(e) => setOwnExhibit(e.target.value)}
          row
          aria-label="own-exhibit"
          name="own-exhibit-group"
        >
          <FormControlLabel value="yes" control={<Radio />} label="自社出展する" />
          <FormControlLabel value="no" control={<Radio />} label="自社出展しない" />
        </RadioGroup>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={handleSave}
          disabled={saving || ownExhibit === ""}
        >
          保存する
        </Button>
        <Box>
          <Typography color='error' variant='h6'>必須書類をご提出ください。また、必要に応じてブース内の子出展者配置図をアップロードください。</Typography>
          <Box sx={{display: 'flex', justifyContent: 'center', gap: 4}}>
            <Box>
              <Typography>必須書類</Typography>
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.r1_status,
                      statusData?.r1_host_status,
                  )
                  )}
                  alt="水道使用申請書ステータス"
                  style={{ width: '60px' }}
                  onClick={() => navigate('/form-require')}
              />
            </Box>
            <Box>
              <Typography>ブース平面図</Typography>
              <img
                  src={getImageByStatus(
                  getPreferredStatus(
                      statusData?.o13_status,
                      statusData?.o13_host_status,
                  )
                  )}
                  alt="水道使用申請書ステータス"
                  style={{ width: '60px' }}
                  onClick={() => navigate('/form-o-13')}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
  };
}

useConfirmBackLogout(navigate);

if (loading) return <div>読み込み中...</div>;

  return (
    <div>
      <SubmissionDeadlineNotice />
      <Header
        title="メッセナゴヤ 共同出展親出展者マイページ"
        companyName={mypageData?.company_name}
      />
       <Container sx={{ display: 'flex' }}>
        <Container sx={{ width: '22%', mt: 4 }}>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
                className={`menu-item`}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  if (canDownload) {
                    handlePdfDownload(mypageData.exhibitor_id, mypageData.company_name);
                  }
                }}
                style={{
                  cursor: canDownload ? "pointer" : "not-allowed",
                  opacity: canDownload ? 1 : 0.5,
                }}
              >
                見積書発行
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://www.messenagoya.jp/policy/privacy', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
        </Container>
        <Container sx={{ width: '80%'}}>
          <p className="remind">
            締切日: {deadline.toLocaleDateString()}(水)<br />
            {remainingDays > 0
              ? `締め切りまであと${remainingDays}日`
              : "締め切りました"}
          </p>
          {/* <FormRequire /> */}
          {/* <Box sx={{ margin: 'auto', mt: 4 }} className="form-status-box">
            <Typography variant="h6" className='form-status-title' gutterBottom>　共同出展者全体申請書提出状況</Typography>
            <Container sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
              <Box sx={{ textAlign: 'center', borderBottom: '1px solid #0071BC', pb: 2 }}>
                  <Typography>全出展者提出書類<br />出展責任者登録、搬入・搬出計画登録</Typography>
                  {renderCoStatusIcon('r1', 'r1 status')}
              </Box>

              <Typography sx={{textAlign: 'center'}}>希望者・対象者提出書類</Typography>

              <Box sx={{ display: 'flex', justifyContent: 'space-around', borderBottom: '1px solid #ccc', pb: 1 }}>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o3', 'o3 status')}
                  <Typography>運送・会場内荷役作業申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o4', 'o4 status')}
                  <Typography>床面工事施工申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o5', 'o5 status')}
                  <Typography>電気(電力)使用申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o6', 'o6 status')}
                  <Typography>電気備品レンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o7', 'o7 status')}
                  <Typography>給排水・エア・ガス工事申込</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-around' , borderBottom: '1px solid #ccc' , pb: 1 }}>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o8', 'o8 status')}
                  <Typography>パッケージ装飾・出展者専用倉庫・名刺交換用iPhoneパッケージプラン申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o9', 'o9 status')}
                  <Typography>装飾備品レンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o10', 'o10 status')}
                  <Typography>PC・ソフトレンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o10_2', 'o10_2 status')}
                  <Typography>インターネット接続申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o11_2', 'o11_2 status')}
                  <Typography>防炎対象物品申請</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'flex-start', pb: 2 }}>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o11', 'o11 status')}
                  <Typography>危険物品の許可申請</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24.5%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o12', 'o12 status')}
                  <Typography>ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  >
                  {renderCoStatusIcon('o13', 'o13 status')}
                  <Typography>ブース平面図</Typography>
                  </Box>
              </Box>
              </Container>
          </Box> */}
          <Box>
            {/* <Typography color='error'>※上記は共同出展者（子）を含めた全体の提出状況確認画面です。<br />上記から申請フォームへは遷移できませんので、下記より申請ください。</Typography> */}
            {renderMainContent()}
          </Box>

          <Box className="notice-box" sx={{ px:2, py:3,  }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
              <Box>
                <Typography variant='h5' className='title' sx={{ mb: 3, px: 4 }}>申請書一覧</Typography>
                <Typography color='error'>※以下より子企業の申請状況を確認いただけます。アイコンをクリックいただくと子企業の申請を代理で行う事ができます。</Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: '10px' }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleChildPDFDownload}
                  disabled={checkedChildPdfIds.length === 0}
                >
                  PDFダウンロード
                </Button>
              </Box>
            </Box>
            <Box sx={{ overflowX: 'auto' }}>
                            {/* 見出しラベル */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0, backgroundColor: '#0071BC', color: '#FFF', textAlign: 'center' , minWidth: '1490px', overflowX: 'hidden' }}>
                <Typography sx={{ padding: '10px 0' ,width: 120, fontWeight: 'bold', borderRight: '1px solid #fff' }}>会社名</Typography>
                {getVisibleFields().map((field) => (
                  <Box
                    key={field.key}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: 110,
                      minHeight: 92,
                      padding: '10px 0',
                      borderRight: '1px solid #fff',
                    }}
                  >
                    <Typography sx={{ fontWeight: 'bold', height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {field.label}
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      color="inherit"
                      sx={{
                        mt: 1,
                        borderColor: '#fff',
                        color: '#fff',
                        '&:hover': {
                          borderColor: '#fff',
                          backgroundColor: 'rgba(255, 255, 255, 0.12)',
                        },
                      }}
                      onClick={() => handleChildColumnSelect(field.key)}
                    >
                      一括
                    </Button>
                  </Box>
                ))}
              </Box>
              <Box>
                <>
                  {paginatedExhibitors.map((exhibitor, index) => {
                    const isEven = index % 2 === 0;

                    return (
                      <Box
                        key={exhibitor.exhibitor_id}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mb: 0,
                          textAlign: 'center',
                          backgroundColor: isEven ? '#f5f5f5' : '#ffffff',
                          border: '1px solid #ccc',
                          minWidth: '1490px',
                          overflowX: 'hidden'
                        }}
                      >
                        {/* 出展者の情報 */}
                        <Typography
                          sx={{
                            width: 120,
                            borderRight: '1px solid #ccc',
                            py: 1 
                          }}
                          onClick={() => {
                            handleMypageOpen(exhibitor.exhibitor_id);
                          }}
                        >
                          {exhibitor.company_name}
                        </Typography>

                                                {/* 出展者書類のステータス画像 */}
                        {getVisibleFields().map((field) => {
                          const { key, label } = field;
                          const currentStatus = getCoExhibitCurrentStatus(exhibitor, field);
                          const imgSrc = getStatusImage(currentStatus);
                          const checkboxId = `${exhibitor.exhibitor_id}_${key}`;
                          const childPdfCheckable = isChildPdfCheckable(exhibitor, field);

                          return (
                            <Box
                              key={key}
                              sx={{
                                width: 110,
                                borderRight: '1px solid #ccc',
                                py: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 2,
                              }}
                            >
                              <img
                                src={imgSrc}
                                alt={`${label} ステータス`}
                                className="max-61"
                                onClick={
                                  !field.contractor
                                    ? () => handleStatusClick(key, exhibitor.exhibitor_id, currentStatus)
                                    : () => {
                                        setSelectedExhibitorId(exhibitor.exhibitor_id);
                                        setSelectedFormKey(key);
                                        setFormModalOpen(true);
                                      }
                                }
                                style={{
                                  cursor: !field.contractor ? 'pointer' : 'default',
                                  opacity: 1,
                                }}
                              />
                              <Checkbox
                                checked={checkedChildPdfIds.includes(checkboxId)}
                                disabled={!childPdfCheckable}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  toggleChildPdfCheck(checkboxId);
                                }}
                              />
                            </Box>
                          );
                        })}

                        {/* モーダル */}
                      
                      </Box>
                    );
                  })}
                </>
              </Box>
              {formModalOpen && (
                <Modal open={formModalOpen} onClose={() => handleFormModalOpenChange(false)}>
                  <Box sx={{ p: 4, backgroundColor: "white", width: "95%", margin: "auto", mt: 10, maxHeight: "90vh", overflowY: "auto", position: "relative" }}>
                    <IconButton onClick={() => handleFormModalOpenChange(false)} sx={{ position: "absolute", top: 8, right: 8 }}>
                      <CloseIcon />
                    </IconButton>
                    {selectedFormKey && selectedExhibitorId != null && renderForm(selectedFormKey, selectedExhibitorId)}
                  </Box>
                </Modal>
              )}

              {mypageModalOpen && (
                <Modal open={mypageModalOpen} onClose={() => setMypageModalOpen(false)}>
                  <Box sx={{ p: 4, backgroundColor: "white", width: "60%", margin: "auto", mt: 10, maxHeight: "80vh", overflowY: "auto", borderRadius: 2, position: "relative" }}>
                    <IconButton onClick={() => setMypageModalOpen(false)} sx={{ position: "absolute", top: 8, right: 8 }}>
                      <CloseIcon />
                    </IconButton>
                    {coMypageLoading ? (
                      <Typography>{"読み込み中..."}</Typography>
                    ) : coMypageError ? (
                      <Typography color="error">{coMypageError}</Typography>
                    ) : coMypageData ? (
                      <Box>
                        <Typography variant="h6" sx={{ mb: 2 }}>マイページ情報</Typography>
                        <Typography>小間番号: {coMypageData.booth_number}</Typography>
                        <Typography>会社名: {coMypageData.company_name}</Typography>
                        <Typography>部署: {coMypageData.department}</Typography>
                        <Typography>担当者名: {coMypageData.user_name}</Typography>
                        <Typography>郵便番号: {coMypageData.zip_code}</Typography>
                        <Typography>住所: {coMypageData.address}</Typography>
                        <Typography>電話番号: {coMypageData.phone_number}</Typography>
                        <Typography>メールアドレス: {coMypageData.email}</Typography>
                      </Box>
                    ) : (
                      <Typography>{"会社情報がありません。"}</Typography>
                    )}
                  </Box>
                </Modal>
              )}

              {/* <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 0,
                  textAlign: 'center',
                  backgroundColor: '#d9eaff',
                  border: '1px solid #ccc',
                  minWidth: '1490px',
                  overflowX: 'hidden'
                }}
              >
                会社名の列は空白か「提出」とか表示
                <Typography sx={{ width: 120, borderRight: '1px solid #ccc', py: 1, fontWeight: 'bold' }}>
                  提出
                </Typography>

                11種類分の提出ボタン
                {getVisibleFields().map((field) => {
                    // categoryごとの振り分け処理（ステータス取得用）
                    let targetKeys = field.key;
                    if ([1, 2].includes(field.category)) {
                      targetKeys = 'r1';
                    } else if ([5, 6].includes(field.category)) {
                      targetKeys = 'o5';
                    }

                    let targetCategory = field.category;
                    if ([1, 2].includes(field.category)) {
                      targetCategory = 1;
                    } else if ([5, 6].includes(field.category)) {
                      targetCategory = 5;
                    }

                    const statusCo = `submission_${targetCategory}_status`

                    // ステータスカラム名
                    const statusColumn = `${targetKeys}_exhibitor_status`;

                    // exhibitorsの中で全員が「提出済み」か「申請しない」かを判定
                    const allSubmittedOrNoApply = exhibitors.every((exhibitor) => {
                      const status = exhibitor[statusColumn];
                      return status === "提出済み" || status === "申請しない";
                    });

                    return (
                      <Box key={field.key} sx={{ width: 110, borderRight: '1px solid #ccc', py: 1 }}>
                        <button
                          disabled={!allSubmittedOrNoApply}
                          style={{
                            padding: '6px 12px',
                            borderRadius: 4,
                            border: 'none',
                            backgroundColor: allSubmittedOrNoApply ? '#0071BC' : '#999999',
                            color: 'white',
                            cursor: allSubmittedOrNoApply ? 'pointer' : 'not-allowed',
                            width: '100%',
                          }}
                          onClick={async () => {
                            if (!allSubmittedOrNoApply) return; // 念のためクリック無効化

                            try {
                              await api.post(`/api/exhibitors/update-status`, {
                                exhibitor_id: user?.exhibitor_id,
                                status_column: statusCo,
                                status_value: "提出済み",
                              });
                              alert(`${field.label} のステータスを更新しました`);
                            } catch (error) {
                              console.error(error);
                              alert("ステータス更新に失敗しました");
                            }
                          }}
                        >
                          提出
                        </button>
                      </Box>
                    );
                  })}
              </Box> */}
            </Box>
          </Box>
          <Box sx={{ mt: 6 }} className="notice-box" id="news">
            <Typography variant="h6" className='notice-title' gutterBottom>
              メッセナゴヤ事務局からのお知らせ
            </Typography>

            {notices
              .filter((notice) => notice.visibility_setting !== '協力会社')
              .filter((notice) => {
                const noticeDate = new Date(notice.date); // notice.date を Date オブジェクトに変換
                return noticeDate <= now; // 現在時刻以前のお知らせのみ
              })
              .map((notice, index) => (
                <Box key={index} sx={{ mb: 2, p: 2 , display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 2,
                      py: 0.5,
                      mb: 0,
                      mx: 0.5,
                      borderRadius: '4px',
                      backgroundColor:
                        notice.category === '緊急' ? '#c1272d' :
                        notice.category === '重要' ? '#f7931e' :
                        '#0071bc',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '20px'
                    }}
                  >
                    {notice.category}
                  </Box>
                  <Typography variant="h6" color="text.secondary" sx={{ mr: 2 }}>
                    {notice.date}
                  </Typography>
                  <Typography variant="h6">{notice.title}</Typography>
                  <Link to={`/news/${notice.notice_id}`} component={RouterLink} sx={{ mt: 1, display: 'block' }}>
                    　詳細を見る
                  </Link>
                </Box>
              ))
            }

            {/* ページネーション */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              {Array.from({ length: Math.ceil(total / noticesPerPage) }).map((_, idx) => (
                <Button
                  key={idx}
                  onClick={() => handlePageChange(idx + 1)}
                  variant={page === idx + 1 ? 'contained' : 'outlined'}
                  sx={{ mx: 0.5 }}
                >
                  {idx + 1}
                </Button>
              ))}
            </Box>
          </Box>
        </Container>
       </Container>
       <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
    </div>
  );
};

export default CoExhibitMypage;
